// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalOverlay_overlay_2mQqAGV","fade":"ModalOverlay_fade_i6WfPHZ","slide":"ModalOverlay_slide_3ar13u3"};